import React, { Fragment, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Table, Button, Pagination, Input, DatePicker, Space, message, Modal, Spin, Select, Checkbox } from 'antd';
import { Col, Row } from 'react-bootstrap';
import Card from '../../../components/bootstrap/card';
import dayjs from 'dayjs';
import { getAllReportTemplatesByType, triggerTemplateExport } from '../../../services/ReportTemplateService';
import CreateReportTemplate from './CreateTemplates';
import TemplateDetailsModal from './TemplateDetailsModal';
import { getAllAdminIECsService } from '../../../services/FileDataService';

const REPORT_TYPE = ['REPORT_BOE', 'REPORT_SHB', 'REPORT_COURIER'];
const { Search } = Input;

const ReportTemplates = () => {
  const [selectedCardType, setSelectedCardType] = useState('REPORT_BOE');
  const [jsonData, setJsonData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState({});
  const [filteredValues, setFilteredValues] = useState([]); // State for filtered users
  const [searchText, setSearchText] = useState("");
  const [exportModalVisible, setExportModalVisible] = useState(false);
  const [exportRecord, setExportRecord] = useState(null);
  const [exportDates, setExportDates] = useState({ from_date: null, to_date: null });
  const [includeFccColumns, setIncludeFccColumns] = useState(false);
  const [userDetails, setUserDetails] = useState({
    role: localStorage.getItem('role'),
    iec: localStorage.getItem('iec_no'),
    name: localStorage.getItem('name')
  })
  const [IECOptions, setIECOptions] = useState([]);
  const [selectedIEC, setSelectedIEC] = useState(
    (localStorage.getItem('role') === 'superadmin' || localStorage.getItem('role') === 'group_head')
      ? null
      : localStorage.getItem('iec_no')
  );
  const [selectedIECName, setSelectedIECName] = useState(
    (localStorage.getItem('role') === 'superadmin' || localStorage.getItem('role') === 'group_head')
      ? ''
      : localStorage.getItem('name')
  )

  const MAX_PAGE_SIZE = 20;
  const location = useLocation();

  const columnNames = [
    {
      header: 'SRN',
      title: 'SRN',
      dataIndex: 'index',
      key: 'index',
      width: 70,
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Details',
      dataIndex: 'details',
      key: 'details',
      width: 100,
      render: (_, record) => {
        return (<Button type="primary" className="cip-btn-submit" onClick={() => viewReportDetails(record)}>Edit</Button>)
      },
    },
    {
      header: 'Download',
      title: 'Download',
      dataIndex: 'Export',
      key: 'Export',
      width: 120,
      render: (_, record) => (
        <Button className='btn btn-primary' onClick={() => handleExport(record)}>EXPORT</Button>
      ),
    },
    {
      header: 'Template Name',
      title: 'Template Name',
      dataIndex: 'template_name',
      key: 'template_name',
      width: 220,
    },
    {
      header: 'Description',
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: 320,
    },
    {
      header: 'Created by',
      title: 'Created by',
      dataIndex: 'fullname',
      key: 'fullname',
      width: 200,
    },
    {
      header: 'Created at',
      title: 'Created at',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 130,
      render: (text) => dayjs(text).format('YYYY-MM-DD'),
    },
    {
      header: 'Updated at',
      title: 'Updated at',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 130,
      render: (text) => text ? dayjs(text).format('YYYY-MM-DD') : '',
    },
  ]

  const getAdminIEC = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await getAllAdminIECsService(token);

      if (response?.data) {
        const options = response.data.map((item, index) => ({
          value: `${item.iec_no};${item.fullname}`,
          label: `${item.iec_no} (${item.fullname})`,
          key: index,
        }));
        setIECOptions(options);
      }
    } catch (err) {
      message.error("Failed to load IEC list");
    }
  };

  const handleIECSelection = (val) => {
    if (val) {
      const [iec_no, iec_name] = val.split(";");
      setSelectedIEC(iec_no);
      setSelectedIECName(iec_name);
    } else {
      setSelectedIEC(null);
      setSelectedIECName('');
    }
  };

  useEffect(() => {
    if (userDetails.role === 'superadmin' || userDetails.role === 'grouphead') {
      getAdminIEC();
    }
  }, []);

  useEffect(() => {
    console.log("location: ", location)
    const params = new URLSearchParams(location.search);
    const cardTypeFromURL = params.get('__report__');
    if (cardTypeFromURL) {
      setSelectedCardType(cardTypeFromURL);
      const page = 1;
      getAllReports(page, cardTypeFromURL);
      if (REPORT_TYPE.includes(cardTypeFromURL)) {
        setTableColumns(columnNames);
      }
    } else {
      setSelectedCardType(''); // Default selected card type
    }
  }, [location.search, selectedIEC]);

  const viewReportDetails = (record) => {
    console.log("record", record);
    setIsModalVisible(true);
    setModalData(record);
  }

  const getAllReports = async (page, cardType) => {
    try {
      const response = await getAllReportTemplatesByType(reportNameMap[cardType], page, MAX_PAGE_SIZE, selectedIEC);
      if (response) {
        console.log("response", response);
        setJsonData([]);
        setJsonData(response.reportemplates);
        setFilteredValues(response.reportemplates);
        setTotalPages(response.total_count);
      }
      else {
        console.log("Null response")
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  const handleSearch = (value) => {
    setSearchText(value);
    if (!value) {
      setFilteredValues(jsonData);
      return;
    }
    const lowercasedValue = value.toLowerCase();
    const filteredData = jsonData.filter((user) =>
      ["template_name", "description"].some((key) =>
        user[key] && String(user[key]).toLowerCase().includes(lowercasedValue)
      )
    );
    setFilteredValues(filteredData);
  };

  const onPageChange = (page) => {
    console.log("page", page);
    setCurrentPage(page);
    getAllReports(page, selectedCardType);
  };

  const handleExport = (record) => {
    setExportRecord(record);
    setExportModalVisible(true); // Show the modal to select dates
  };

  // starts backgroud export
  const confirmExport = async () => {
    if (!exportDates.from_date || !exportDates.to_date) {
      message.warning("Please select both From and To dates.");
      return;
    }

    if (exportDates.to_date.isBefore(exportDates.from_date)) {
      message.error('To-date cannot be before from-date');
      return;
    }

    const oneYearLater = exportDates.from_date.add(1, 'year');
    if (exportDates.to_date.isAfter(oneYearLater)) {
      message.error("The selected duration should not exceed 1 year.");
      return;
    }

    try {
      setIsLoading(true);
      const filters = {
        from_date: exportDates.from_date.format('YYYY-MM-DD'),
        to_date: exportDates.to_date.format('YYYY-MM-DD')
      };
      await triggerTemplateExport(exportRecord.id, selectedIEC, filters, includeFccColumns);
      message.success('Export started in background. Check the Downloads panel for progress.');

      setExportModalVisible(false);
      setExportDates({ from_date: null, to_date: null }); // Reset dates
    } catch (error) {
      message.error("Failed to start export. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };


  const reportNameMap = { //mapping to retrive table name from json file
    REPORT_COURIER: "Courier Bill Report",
    REPORT_SHB: "Shipping Bill Report",
    REPORT_BOE: "Bill Of Entry Report"
  };

  return (
    <Fragment>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title d-flex align-items-center">
                <h4 className="card-title">Report - {selectedCardType.replace(/REPORT_/g, "").replace(/_/g, " ")}</h4>
              </div>
              <div>
                <button onClick={() => setModalVisible(true)}
                  className='btn btn-primary'
                >
                  Create +
                </button>
              </div>
            </Card.Header>
            <Card.Body className="px-0">
              {REPORT_TYPE.includes(selectedCardType) && (
                <Search
                  placeholder="Search"
                  allowClear
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 250, marginLeft: 15, marginBottom: 15 }}
                />
              )}
              <TemplateDetailsModal
                visible={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                id={modalData.id} // The template id
                type_name={reportNameMap[selectedCardType]}
                iec={modalData.iec_no}
                onDelete={(id) => getAllReports(1, new URLSearchParams(location.search).get('__report__'))}
                onEdit={(id) => getAllReports(1, new URLSearchParams(location.search).get('__report__'))}
              />
              <CreateReportTemplate
                type_name={reportNameMap[selectedCardType]}
                iec_no={modalData.iec_no}
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                onSubmit={() => {
                  getAllReports(1, new URLSearchParams(location.search).get('__report__'))
                }}
              />
              <div className="table-responsive">
                <Table bordered columns={tableColumns} dataSource={filteredValues} loading={isLoading} pagination={false} scroll={{ x: 'max-content' }} />
                <br />
                <Pagination current={currentPage} defaultPageSize={MAX_PAGE_SIZE} total={totalPages} onChange={onPageChange} align="end" />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal
        title="Export Report"
        open={exportModalVisible}
        onCancel={() => setExportModalVisible(false)}
        onOk={confirmExport}
        okText="Start Export"
        okButtonProps={{ disabled: isLoading }}
        cancelButtonProps={{ disabled: isLoading }}
      >
        {(userDetails.role == "superadmin") &&
          <Select
            showSearch
            placeholder="Select IEC"
            onChange={handleIECSelection}
            allowClear
            options={IECOptions}
            style={{ width: '100%' }}
            value={selectedIEC ? `${selectedIEC};${selectedIECName}` : undefined}
          />}
        <Spin spinning={isLoading}>
          <p>Please select the date range:</p>
          <Space direction="vertical" size={12} style={{ width: '100%' }}>
            <DatePicker
              style={{ width: '100%' }}
              placeholder="From Date"
              value={exportDates.from_date}
              onChange={(date) => setExportDates((prev) => ({ ...prev, from_date: date }))}
            />
            <DatePicker
              style={{ width: '100%' }}
              placeholder="To Date"
              value={exportDates.to_date}
              onChange={(date) => setExportDates((prev) => ({ ...prev, to_date: date }))}
            />
          </Space>
          <div style={{ marginTop: 12 }}>
            <Checkbox
              checked={includeFccColumns}
              onChange={(e) => setIncludeFccColumns(e.target.checked)}
            >
              Include FCC Columns
            </Checkbox>
          </div>
        </Spin>
      </Modal>

    </Fragment>
  );
}

export default ReportTemplates;